import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "preview__button"
}
const _hoisted_2 = {
  key: 4,
  class: "preview__text"
}
const _hoisted_3 = {
  key: 5,
  class: "preview__text"
}
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 8,
  class: "no-preview"
}
const _hoisted_7 = { class: "no-preview__text" }

import pdfvuer from 'pdfvuer/src/Pdfvuer.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { useI18n } from 'vue-i18n'
import { computed, ref, toRefs, watch } from 'vue'
import { DirectoryItem } from './types'
import IconMediumEyeOff from '@/design-system/assets/icons/IconMediumEyeOff.vue'
import 'pdfjs-dist/build/pdf.worker.entry'
import IconFileSearch2 from '@/design-system/assets/icons/IconFileSearch2.vue'
import MarkDown from '@/components/MarkDown.vue'
import { PreviewType } from './useFilePreview'

type Props = {
  newPage?: number
  fullscreen?: boolean
  previewFile: DirectoryItem
  previewType: PreviewType
  fileBlobSource: string | undefined
  textContent: string | undefined
  loadingFile: boolean
  fileErrorText: string | undefined
}

export default /*@__PURE__*/_defineComponent({
  __name: 'FilePreview',
  props: {
    newPage: { default: undefined },
    fullscreen: { type: Boolean, default: false },
    previewFile: { default: undefined },
    previewType: { default: 'none' },
    fileBlobSource: {},
    textContent: {},
    loadingFile: { type: Boolean },
    fileErrorText: {}
  },
  emits: ["preview-file", "pdf-numpages", "pdf-page", "pdf-error"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const {
  newPage,
  previewFile,
  previewType,
  fileBlobSource,
  textContent,
  loadingFile,
  fileErrorText
} = toRefs(props)

const emit = __emit

const { t } = useI18n()
const previewHovered = ref(false)
const pdfNumPages = ref(1)
const pdfCurrentPage = ref(1)
const pdfError = ref<string | null>(null)
const filePreviewFailed = ref(false)
const showPreviewFailedContainer = computed(() => {
  return pdfError.value != null || filePreviewFailed.value
})

function openPreviewModal() {
  if (previewFile.value) {
    emit('preview-file', previewFile.value)
  }
}
function setPreviewHovered(hovered: boolean) {
  previewHovered.value = hovered
}

function handlePdfError(error: any) {
  let errorMessage = 'PDF rendering failed.'
  if (error && error.message) {
    errorMessage = error.message
  } else if (typeof error === 'string') {
    errorMessage = error
  }
  pdfError.value = errorMessage
}
watch(
  pdfCurrentPage,
  (newPage) => {
    emit('pdf-page', newPage)
  },
  { immediate: true }
)
watch(
  pdfNumPages,
  (newNumPages) => {
    emit('pdf-numpages', newNumPages)
  },
  { immediate: true }
)
watch(
  newPage,
  (newPageValue) => {
    if (newPageValue && newPageValue > 0) {
      pdfCurrentPage.value = newPageValue
    }
  },
  { immediate: true, deep: true }
)
watch(
  pdfError,
  (newError) => {
    emit('pdf-error', newError)
  },
  { immediate: true }
)

function setNumPages(numPages: number) {
  pdfNumPages.value = numPages
}

return (_ctx: any,_cache: any) => {
  return (_unref(previewFile))
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(['preview', { 'preview--fullscreen': _ctx.fullscreen }]),
        onClick: openPreviewModal,
        onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (setPreviewHovered(true))),
        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (setPreviewHovered(false)))
      }, [
        (
        _ctx.fullscreen &&
        previewHovered.value &&
        !_unref(loadingFile) &&
        !showPreviewFailedContainer.value &&
        _unref(previewType) !== 'none'
      )
          ? (_openBlock(), _createElementBlock("button", _hoisted_1, [
              _createVNode(IconFileSearch2, { class: "preview__button__icon" })
            ]))
          : _createCommentVNode("", true),
        (_unref(loadingFile) && !showPreviewFailedContainer.value)
          ? (_openBlock(), _createBlock(PulseLoader, {
              key: 1,
              class: "preview__loading-spinner",
              color: "#3f46d6",
              size: "16px"
            }))
          : (
        _unref(previewType) === 'pdf' &&
        _ctx.fullscreen &&
        !_unref(loadingFile) &&
        !showPreviewFailedContainer.value &&
        _unref(fileBlobSource)
      )
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(pdfvuer), {
                key: 2,
                class: _normalizeClass(["preview__pdf", { preview__pdf__hover: previewHovered.value }]),
                page: 1,
                src: _unref(fileBlobSource)
              }, null, 8, ["class", "src"]))
            : (
        _unref(previewType) === 'pdf' &&
        !_ctx.fullscreen &&
        !_unref(loadingFile) &&
        !showPreviewFailedContainer.value &&
        _unref(fileBlobSource)
      )
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(pdfvuer), {
                  key: 3,
                  class: "preview__overflow-hidden__pdf",
                  src: _unref(fileBlobSource),
                  page: pdfCurrentPage.value,
                  onNumpages: setNumPages,
                  onError: handlePdfError
                }, null, 40, ["src", "page"]))
              : (
        _unref(previewType) === 'text' && !_unref(loadingFile) && !showPreviewFailedContainer.value && _unref(textContent)
      )
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(textContent)), 1))
                : (
        _unref(previewType) === 'markdown' && !_unref(loadingFile) && !showPreviewFailedContainer.value && _unref(textContent)
      )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(MarkDown, {
                        source: _unref(textContent) || _unref(t)('general__text__preview-not-available-for-file-type')
                      }, null, 8, ["source"])
                    ]))
                  : (_unref(previewType) === 'image' && !_unref(loadingFile) && !showPreviewFailedContainer.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 6,
                        class: _normalizeClass(["preview__image", { preview__image__hover: previewHovered.value }]),
                        src: _unref(fileBlobSource),
                        alt: _unref(t)('general__text__preview-click-to')
                      }, null, 10, _hoisted_4))
                    : (_unref(previewType) === 'video' && !_unref(loadingFile) && !showPreviewFailedContainer.value)
                      ? (_openBlock(), _createElementBlock("video", {
                          key: _unref(fileBlobSource),
                          class: "preview__image",
                          controls: "",
                          autoplay: "",
                          src: _unref(fileBlobSource)
                        }, _toDisplayString(_unref(t)('general__text__preview-not-available-for-file-type')), 9, _hoisted_5))
                      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(IconMediumEyeOff),
                          _createElementVNode("p", _hoisted_7, _toDisplayString((pdfError.value ? pdfError.value : _unref(fileErrorText)) ??
          _unref(t)('general__text__preview-not-available-for-file-type')) + ". ", 1)
                        ]))
      ], 34))
    : _createCommentVNode("", true)
}
}

})